import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

// Sports- og idrætsstævne business information schema
export const SPORTS_EVENTS_AND_TOURNAMENTS_CONTENT_PATH =
  'licenses.steps.businessInformation.forms.sportsEventsAndTournaments';

export const sportsEventsAndTournamentsSchema = BasicBusinessInformationSchema.extend({
  eventName: z.string().min(1, {
    message: `${SPORTS_EVENTS_AND_TOURNAMENTS_CONTENT_PATH}.eventName.validation.required`,
  }),
  eventDate: z
    .string()
    .min(1, {
      message: `${SPORTS_EVENTS_AND_TOURNAMENTS_CONTENT_PATH}.eventDate.validation.required`,
    })
    .regex(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/, {
      message: `${SPORTS_EVENTS_AND_TOURNAMENTS_CONTENT_PATH}.eventDate.validation.validFormat`,
    }),
  spectatorsCount: z
    .number({
      required_error: `${SPORTS_EVENTS_AND_TOURNAMENTS_CONTENT_PATH}.spectatorsCount.validation.required`,
    })
    .int({
      message: `${SPORTS_EVENTS_AND_TOURNAMENTS_CONTENT_PATH}.spectatorsCount.validation.required`,
    })
    .min(1, {
      message: `${SPORTS_EVENTS_AND_TOURNAMENTS_CONTENT_PATH}.spectatorsCount.validation.required`,
    }),
});

export type SportsEventsAndTournamentsForm = z.infer<typeof sportsEventsAndTournamentsSchema>;

export const createSportsEventsAndTournamentsDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.SportsEventsAndTournaments,
  eventName: '',
  eventDate: '',
});

export const toPayloadSportsEventsAndTournaments = (
  form: SportsEventsAndTournamentsForm,
  wareNumber: number,
): GeneralPayload => {
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(form.eventDate).format('YYYY-MM-DD'),
    quantity: form.spectatorsCount ?? 0,
  };
};
